import type { SVGProps } from 'react'
const SvgAcionEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="acion-edit_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" fill="#D9D9D9" />
    </mask>
    <g mask="url(#acion-edit_svg__a)">
      <path
        d="M3.153 15.862a.79.79 0 0 1-.787-.226.8.8 0 0 1-.228-.79l.754-3.617 3.879 3.879zm3.618-.754-3.879-3.879 8.583-8.583q.495-.494 1.212-.494.719 0 1.213.494L15.354 4.1q.494.495.494 1.213 0 .717-.495 1.212zm5.916-11.264L5.02 11.513l1.468 1.468 7.669-7.668z"
        fill="silver"
      />
    </g>
  </svg>
)
export default SvgAcionEdit
